import { FC } from 'react';

import { IconCreditCard } from '@purpur/library/icon/credit-card';
import { IconDelivery } from '@purpur/library/icon/delivery';
import { IconReverse } from '@purpur/library/icon/reverse';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';

import { ORDER_CART_TEST_ID } from '../../constants';
import { ValuePromptList, ValuePromptListItem } from './CartValuePrompts.styles';

export const CartValuePrompts: FC = () => {
    const segment = useSegment();
    const { t } = useTranslations();

    const valuePromptsB2B = [
        {
            icon: IconDelivery,
            title: t['order_cart.vas.free_delivery_b2b.title'],
        },
    ];
    const valuePromptsB2C = [
        {
            icon: IconDelivery,
            title: t['order_cart.vas.free_delivery.title'],
        },
        {
            icon: IconReverse,
            title: t['order_cart.vas.money_back_guarantee.title'],
        },
        {
            icon: IconCreditCard,
            title: t['order_cart.vas.payment.title'],
        },
    ];

    const valuePrompts = segment === TeliaSegment.B2b ? valuePromptsB2B : valuePromptsB2C;

    return (
        <ValuePromptList aria-label={t['order_cart.vas.a11y_title']} data-test={ORDER_CART_TEST_ID.VALUE_PROMPTS}>
            {valuePrompts.map(({ icon: IconCmp, title }) => (
                <ValuePromptListItem key={title}>
                    <IconCmp size="md" />
                    {title}
                </ValuePromptListItem>
            ))}
        </ValuePromptList>
    );
};
